import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import i18n from '../../utils/i18n';
import Button from '@adsk/bim360-matrix-react-button';
import SvgIcon from '@adsk/bim360-matrix-react-svg-icon';
import IconButton from '@adsk/bim360-matrix-react-icon-button';
import StickyScrollableContainer from '@adsk/bim360-matrix-react-sticky-scrollable-container';
import {childrenType} from '../../constants/proptype-validation';
import closeIcon from '../../assets/images/icons/icon-close.svg';

const FilterPanel = props => {
  const {isFilterPanelOpen, isFiltered, resetFilters, closeFilterPanel, children} = props;

  const filterClassName = cx('FilterPanel', {
    'FilterPanel--open': isFilterPanelOpen
  });

  return (
    <div className={filterClassName}>
      <StickyScrollableContainer>
        <StickyScrollableContainer.Header className="FilterPanel__header">
          <div className="FilterPanel__title">{i18n.t('filter.filters')}</div>
          {isFiltered && (
            <Button styleType={Button.StyleType.INLINE_LINK} className="FilterPanel__reset" onClick={resetFilters}>
              {i18n.t('filter.clearAll')}
            </Button>
          )}
          <IconButton onClick={closeFilterPanel} className="FilterPanel__close-icon">
            <SvgIcon height="16px" width="16px">
              {closeIcon}
            </SvgIcon>
          </IconButton>
        </StickyScrollableContainer.Header>
        <StickyScrollableContainer.Content className="FilterPanel__content">
          {children}
        </StickyScrollableContainer.Content>
      </StickyScrollableContainer>
    </div>
  );
};

FilterPanel.displayName = 'FilterPanel';

FilterPanel.propTypes = {
  closeFilterPanel: PropTypes.func.isRequired,
  resetFilters: PropTypes.func.isRequired,
  isFiltered: PropTypes.bool.isRequired,
  isFilterPanelOpen: PropTypes.bool.isRequired,
  children: childrenType.isRequired
};

export default FilterPanel;
